import { RepayEarly } from './RepayEarly';
import { OngoingPaymentPlan } from '../../Dashboard.types';
import OrderSummary from '../OrderSummary/OrderSummary';

export const OngoingLoanView = ({
  paymentPlan,
}: {
  paymentPlan: OngoingPaymentPlan;
}) => {
  return (
    <div className="flex flex-col gap-l" data-testid="ongoing-view">
      <div className="flex flex-col gap-l">
        <div>
          <RepayEarly paymentPlan={paymentPlan} />
        </div>
        <OrderSummary paymentPlan={paymentPlan} />
      </div>
    </div>
  );
};
